import { sriClient } from 'ReduxLoop/utils/apiConfig';

export const getWorkgroupInfo = async (ou) => {
  const workgroup = (
    await sriClient.getAll('/workgroups', { organisationalUnit: ou.$$meta.permalink })
  )[0];
  const memberRelations = await sriClient.getAll('/kathondvla/organisationalunits/relations', {
    type: 'IS_MEMBER_OF',
    to: ou.$$meta.permalink,
    expand: 'results.from',
    status: 'ACTIVE',
  });
  const memberOus = memberRelations.map((rel) => rel.from.$$expanded);
  // const presidents = memberOus.length === 0 ? [] : await sriClient.getAll('/responsibilities', { organisations: memberRelations.map(rel => rel.from.href), positions: VOORZITTER, expandPerson: 'SUMMARY' });
  const memberParentRelations =
    memberOus.length === 0
      ? []
      : await sriClient.getList('/kathondvla/organisationalunits/relations', {
          fromRecursive: memberRelations.map((rel) => rel.from.href),
          type: 'IS_PART_OF',
          status: 'ACTIVE',
          expand: 'results.to',
        });
  return {
    workgroup,
    memberRelations,
    memberOus,
    // presidents,
    memberParentRelations,
  };
};

export const getWorkgroup = async (ouHref) => {
  return (await sriClient.getAll('/workgroups', { organisationalUnit: ouHref }))[0];
};
